const mock = [{
  title: "Data",
  content: "xx/xx/22"
}, {
  title: "Título",
  content: "Lorem Ipsum"
}, {
  title: "Autores",
  content: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Sapiente, eveniet fuga? Quam distinctio repudiandae nihil quisquam dicta placeat molestiae fugit, explicabo cupiditate?"
}];

export default mock;